import { types, Instance } from 'mobx-state-tree';

import ModificationModel from '@/stores/models/ModificationModel';

const UserModificationModel = types.model('UserModificationModel', {
  id: types.number,
  modification: ModificationModel,
});

export type IUserModificationModel = Instance<typeof UserModificationModel>;

export default UserModificationModel;
